
import Vue, { defineComponent } from "vue";
export default defineComponent({
  name: "filmSvg",
  components: {},
  props: {
    color: {
      type: String,
      default: "black",
    },
  },
});
